var map = {
	"./postitus1.png": 21445,
	"./postitus2.png": 12351,
	"./postitus3.png": 23212,
	"./postitus4.png": 24849,
	"./postitus5.png": 91256,
	"./postitus6.png": 84315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56861;